import { ActionIcon, Container, Group, Paper, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useRouter } from 'next/router';
import React from 'react';
import styles from './appBar.module.css';

interface AppBarProps {
  text?: string;
  leftActions?: React.ReactNode;
  rightActions?: React.ReactNode;
}

function AppBar({ text, rightActions = null, leftActions }: AppBarProps) {
  const router = useRouter();

  let rightActionsComponent = rightActions;
  if (rightActions === null) {
    rightActionsComponent = (
      <ActionIcon size="lg" color="brand" onClick={router.back}>
        <IconChevronRight size="1.1rem" />
      </ActionIcon>
    );
  }

  return (
    <header style={{ height: 56, marginBottom: '24px' }}>
      <Paper shadow="xs" p={0} style={{ borderRadius: 0 }}>
        <Container className={styles.inner} size="lg">
          <Group gap={0} left="right" wrap="nowrap">
            {rightActionsComponent}
          </Group>

          <Text size="sm">{text}</Text>

          <Group gap={0} align="right" wrap="nowrap">
            {leftActions}
          </Group>
        </Container>
      </Paper>
    </header>
  );
}

export default AppBar;
